"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Scoreboard = void 0;

var _react = _interopRequireDefault(require("react"));

var _color = _interopRequireDefault(require("color"));

var _atoms = require("../../atoms");

var _getProperty = require("../../util/getProperty");

var _helpers = require("../../util/helpers");

require("./Scoreboard.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
var Scoreboard = function Scoreboard(_ref) {
  var game = _ref.game;
  var homeTeamAbr = (0, _getProperty.getProperty)("home_team.abbr", game, "--");
  var homeTeamColor = (0, _getProperty.getProperty)("home_team.jersey_color", game, "#000000");
  var homeTeamScore = (0, _getProperty.getProperty)("home_team.score", game, "--");
  var awayTeamAbr = (0, _getProperty.getProperty)("away_team.abbr", game, "--");
  var awayTeamColor = (0, _getProperty.getProperty)("away_team.jersey_color", game, "#ffffff");
  var awayTeamScore = (0, _getProperty.getProperty)("away_team.score", game, "--");
  var teamStyle = {
    backgroundColor: "#000",
    color: "#fff"
  };

  var getStyles = function getStyles(teamColor) {
    var showBorder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var tc = "";

    try {
      tc = (0, _color.default)(teamColor);
    } catch (e) {
      tc = (0, _color.default)("#000");
      tc = "#000";
    }

    teamStyle = {
      backgroundColor: tc,
      color: tc.luminosity() > 0.59 ? "#000" : "#fff",
      border: showBorder && ((0, _helpers.isSmallScreen)() || (0, _helpers.isLandscape)()) && tc.luminosity() > 0.59 ? "1px solid var(--grey3-color)" : "unset"
    };
    return teamStyle;
  };

  return /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    className: "Scoreboard"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "scoreboard-home-team",
    style: getStyles(homeTeamColor)
  }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    hideXS: true,
    content: homeTeamAbr.substring(0, 5),
    color: _color.default.White1,
    style: getStyles(homeTeamColor, false),
    className: "team-name"
  })), /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "scoreboard-result"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Row, null, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    content: homeTeamScore,
    marginRight: "1",
    color: _atoms.Color.White1,
    className: "score"
  }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: _atoms.Label.Type.Title5,
    content: "-",
    color: _atoms.Color.White1,
    className: "score"
  }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    content: awayTeamScore,
    marginLeft: "1",
    color: _atoms.Color.White1,
    className: "score"
  }))), /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "scoreboard-away-team",
    style: getStyles(awayTeamColor)
  }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    hideXS: true,
    content: awayTeamAbr.substring(0, 5),
    color: _atoms.Color.White1,
    style: getStyles(awayTeamColor, false),
    className: "team-name"
  })));
};

exports.Scoreboard = Scoreboard;